//GET_COUNTRY

export const setCountry = (countryData) => ({
    type: 'SET_COUNTRY',
    data: countryData
});


// WEBPACK FOOTER //
// ./src/actions/country.js